module.exports = __webpack_public_path__ + "static/media/loc3_img4.eb49f49e.jpg";